import { sub } from "date-fns";

/* o CTeFilter sem o tomador: no lugar dele, as UFs de inicio e fim do percurso */
export class MDFeFilter {
    status: string = '';
    statusLabel: string = 'Todos';
    numDoc: string = "";
    startUf: string = "";
    endUf: string = "";
    vlrMinCarga: number | null = null;
    vlrMaxCarga: number | null = null;
    serie: string = "";
    chaveMdfe: string = "";
    branchesIds: string | null = null;
    branchesCodes: string | null = null;
    companyId: number | null = null;
    ids: string = "";

    initialDateObj?: Date = sub(new Date(), { months: 1 });
    finalDateObj?: Date = new Date();
}
